<template>
  <a
    :href="kbopubUrl"
    target="_blank"
    rel="noopener noreferrer"
    class="flex items-center space-x-2 py-2 duration-200"
  >
    <img
      :src="faviconUrl"
      alt="KBO favicon"
      class="w-6 h-6 rounded mr-8"
      @error="fallbackFavicon"
    />
    <span class="text-black-600 text-sm hover:text-blue-800 transition-transform duration-200 hover:scale-105 flex items-center">
      {{ $gettext("Page BCE") }}
    </span>
  </a>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
  enterpriseNumber: { type: String, required: true }
})

const cleanedEnterpriseNumber = computed(() =>
  props.enterpriseNumber.replace(/\D/g, '')
)
const kbopubUrl = computed(() =>
  `https://kbopub.economie.fgov.be/kbopub/toonondernemingps.html?lang=fr&ondernemingsnummer=${cleanedEnterpriseNumber.value}`
)

const faviconUrl = ref('https://kbopub.economie.fgov.be/favicon.ico')

function fallbackFavicon(event) {
  event.target.src = 'https://www.google.com/s2/favicons?domain=kbopub.economie.fgov.be'
}
</script>
